<form [formGroup]="myform" autocomplete="off" (ngSubmit)="submitEvent()">
    <div class="bc-row bc-mt-3 bc-text-center">
        <div class="bc-col-12">

            <div class="main"> 
                <div class="card"> 
                    <div class="form"> 
                        <input        
                        type="radio"             
                        value="numerofactura"            
                        formControlName="radioButton" (click)="emitirValores()">         
                        <label class="custom-control-label bc-me-4">No. Factura</label>
                        <input 
                        type="radio" 
                        value="nit" 
                        formControlName="radioButton" (click)="emitirValores()">
                        <label class="custom-control-label  bc-me-4">Nit</label>
                        <input 
                        type="radio" 
                        value="ciudad" 
                        formControlName="radioButton" (click)="emitirValores()">
                        <label class="custom-control-label">Ciudad</label>                       
                    </div> 
                </div> 
            </div> 

        </div>
    </div>
    <div class="bc-row-lg bc-mt-2">
        <div class="bc-col-lg-4"></div>
        <div class="bc-col-lg-4">
            <div class="omrs-input-group">
                <label class="omrs-input-underlined">
                  <input (keyup)="emitirValores()" formControlName="data" required>
                  <span class="omrs-input-label">Mi búsqueda</span>
        
                  <svg (click)="submitEvent()" width="54" height="54" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_dd_930_3757)">
                    <rect x="8" y="8" width="48" height="48" rx="24" fill="white" fill-opacity="0.01"/>
                    </g>
                    <mask id="mask0_930_3757" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="8" y="8" width="48" height="48">
                    <rect x="8" y="8" width="48" height="48" rx="24" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_930_3757)">
                    <rect x="-8.42096" y="-8.4209" width="80.8421" height="80.8421" fill="#DD3542"/>
                    <rect x="-8.42096" y="-8.4209" width="80.8421" height="80.8421" fill="white" fill-opacity="0.01"/>
                    </g>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M31.1765 36.9413C34.3602 36.9413 36.9412 34.3604 36.9412 31.1766C36.9412 27.9929 34.3602 25.4119 31.1765 25.4119C27.9927 25.4119 25.4118 27.9929 25.4118 31.1766C25.4118 34.3604 27.9927 36.9413 31.1765 36.9413ZM36.1172 35.535C37.1425 34.3735 37.7647 32.8477 37.7647 31.1766C37.7647 27.538 34.815 24.5884 31.1765 24.5884C27.5379 24.5884 24.5882 27.538 24.5882 31.1766C24.5882 34.8152 27.5379 37.7648 31.1765 37.7648C32.8476 37.7648 34.3734 37.1427 35.5348 36.1173L39.5324 40.1149L40.1147 39.5325L36.1172 35.535ZM30.3529 27.4707C28.7611 27.4707 27.4706 28.7612 27.4706 30.3531H26.647C26.647 28.3064 28.3062 26.6472 30.3529 26.6472V27.4707Z" fill="white"/>
                    <defs>
                    <filter id="filter0_dd_930_3757" x="5" y="6" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="1"/>
                    <feGaussianBlur stdDeviation="1.5"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.100515 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_930_3757"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="1"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
                    <feBlend mode="normal" in2="effect1_dropShadow_930_3757" result="effect2_dropShadow_930_3757"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_930_3757" result="shape"/>
                    </filter>
                    </defs>
                    </svg> 
                </label>
            </div>
        </div>        
        <div class="bc-col-4"></div>
    </div>


    

</form>